<template>
  <modal
    ref="messageUploadPending"
    template="question"
    title="Pendência"
    ref-name="messageUploadPending"
    first-button-text="VOLTAR"
    :icon-enabled="false"
    second-button-text="CONCLUIR"
    :close-button-enabled="isPendencyReplied ? true : false"
    :first-button-disabled="isPendencyReplyLoading"
    :second-button-disabled="disableSecoundButton()"
    class="pendencies-modal"
    :class="isPendencyReplied ? 'replied' : ''"
    @first-cta="closeModal()"
    @second-cta="submitReply()"
  >
    <div class="reply-pendency-modal">
      <div
        v-if="isPendencyReplyLoading"
        class="reply-pendency-modal__loading"
      >
        <h2>Salvando mensagem...</h2>
        <loading />
      </div>
      <div
        v-else
        class="reply-pendency-modal__regular"
      >
        <div class="pendency-summary">
          <h4>Motivo</h4>
          <p v-if="pendency">
            {{ pendency.reason }}
          </p>
          <p v-else>
            -
          </p>

          <h4>Observação</h4>
          <p v-if="pendency.description">
            {{ pendency.description }}
          </p>
          <p v-else>
            -
          </p>
        </div>

        <div class="text-area-container">
          <h2 v-if="isPendencyReplied">
            Mensagem de tratativa anexada
          </h2>
          <h2 v-else>
            Anexar mensagem de tratativa
          </h2>
          <textarea
            ref="textArea"
            v-model="replyTxt"
            class="text-area"
            name="message-attached"
            cols="20"
            rows="8"
            placeholder="Digite sua mensagem..."
            :disabled="isPendencyReplied"
            maxlength="255"
          />
        </div>
        <upload-input :pendency="pendency" />
      </div>
    </div>
  </modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import notify from '@/api/notification'
import { PENDENCIES_STATUS_REPLIED } from '@/enums'
import Moment from 'moment'
import UploadInput from './PendenciesUploadInput'

export default {
  name: 'ReplyPendencyModal',
  components: {
    'upload-input': UploadInput
  },
  props: {
    pendency: {
      type: Object
    }
  },
  data() {
    return {
      replyTxt: '',
      updated: false
    }
  },
  computed: {
    ...mapGetters(['pendencyUploadStatus', 'pendencyReplyStatus', 'profile']),
    hasFileUploaded: function () {
      return Object.keys(this.pendency).length > 0
        ? this.pendency.files.length > 0
        : false
    },
    isPendencyReplyLoading: function () {
      return this.pendencyReplyStatus === 'STATUS_LOADING'
    },
    isPendencyReplied: function () {
      return Object.keys(this.pendency).length > 0
        ? this.pendency.status === PENDENCIES_STATUS_REPLIED
        : false
    }
  },
  watch: {
    pendencyReplyStatus: function (newValue) {
      if (newValue === 'STATUS_SUCCESS') {
        this.closeModal()
      }
    },
    pendency: function (newValue) {
      if (newValue.resolution) {
        this.replyTxt = this.removeHtmlLinkTagFromString(newValue.resolution)
        let str = this.replyTxt
        if (!str || str.length === 0 || /^\s*$/.test(str)) {
          this.replyTxt = 'Não existe nenhuma mensagem de tratativa anexada'
        }
      } else {
        this.replyTxt = ''
      }
    }
  },
  methods: {
    ...mapActions([
      'replyPendency',
      'setUploadStatus',
      'deleteStoreFile',
      'checkFilesUploaded',
      'saveCurrrentText'
    ]),
    openModal() {
      this.setUploadStatus('STATUS_INITIAL')
      this.$refs.messageUploadPending.open()
      this.updated = false
    },
    closeModal() {
      this.checkFilesUploaded(this.pendency.id)
      this.saveCurrrentText({ pendencyId: this.pendency.id, text: this.replyTxt })
      this.$refs.messageUploadPending.close()
      this.$emit('closed')
      if (this.updated) {
        this.$emit('updated')
      }
    },
    disableSecoundButton() {
      if (this.isPendencyReplyLoading) return true
      if (this.pendencyUploadStatus === 'UPLOAD_STARTED') return true
      if (this.pendency.files && this.pendency.files.length === 0) {
        if (this.replyTxt.length === 0) {
          return true
        }
      }
      if (this.replyTxt && this.replyTxt.length > 0) return false
      let error = this.pendencyUploadStatus === 'UPLOAD_ERROR'
      if (this.pendency.files) {
        for (let file in this.pendency.files) {
          if (this.pendency.files[file].error) {
            error = true
          } else {
            return false
          }
        }
        return error
      }
      return true
    },
    downloadUploadedFile(url) {
      window.open(url)
      this.submitAnalyticsEvent('Download de upload realizado pelo usuario')
    },
    submitReply() {
      this.checkFilesUploaded(this.pendency.id)
      let uploadedSuccess = this.hasFileUploaded || this.pendencyUploadStatus === 'STATUS_SUCCESS'
      let isMessageFilled = this.replyTxt.length > 0
      if (isMessageFilled || uploadedSuccess) {
        this.replyPendency({
          pendencyId: this.pendency.id,
          resolution: this.replyTxt
        })
        this.updated = true
        this.submitAnalyticsEvent('Pendencia respondida - Mensagem: ' + isMessageFilled + ', Upload: ' + uploadedSuccess)
        this.pushPendencyTimeSpentToReply()
      } else {
        notify({
          title: 'AVISO:',
          message: 'Preencha a mensagem ou/e faça upload de um arquivo'
        })
        this.$refs.textArea.focus()
      }
    },
    removeHtmlLinkTagFromString(string) {
      return string.replace(/<a.*>.*?<\/a>/ig, '')
    },
    submitAnalyticsEvent(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        'category': 'Gestao de Pendencias',
        'action': action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName,
        'pendency-id': this.pendency.id,
        'created-at': this.pendency.createdAt
      })
    },
    pushPendencyTimeSpentToReply() {
      let now = Moment(new Date())
      let timeSpentToReplyPendency = now.diff(this.pendency.createdAt, 'hours')

      this.$analytics.pushAnalyticsEvent('ga-event', {
        'category': 'Gestao de Pendencias',
        'action': 'Tempo de resposta em horas',
        'label': timeSpentToReplyPendency,
        'value': timeSpentToReplyPendency,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName,
        'pendency-id': this.pendency.id,
        'created-at': this.pendency.createdAt
      })
    }
  },
}
</script>

<style lang="scss">
.replied {
  .md-dialog {
    .md-dialog-content {
      .standard-modal__container-cta {
        display: none;
      }
    }
  }
}

.reply-pendency-modal {
  &__loading {
    h2 {
      margin: auto;
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 21px;
      text-align: center;
      padding: 1em 0 17px;
    }
  }

  &__regular {
    .pendency-summary {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-size: 12px;
      line-height: 14px;
      margin-bottom: 2em;
      background: white;
      padding: 0 3em 1.5em;
      transform: translateY(0) translateX(-34px);
      width: calc(100% + 68px);
      margin-top: 0;

      h4 {
        font-weight: bold;
        text-transform: uppercase;
        color: #7f1a54;
        font-size: 12px;
      }

      p {
        font-size: 12px;
        font-style: normal;
        color: #7a7a7a;
      }
    }

    .text-area-container {
      display: flex;
      flex-direction: column;
      text-align: end;
      margin-bottom: 20px;

      h2 {
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        color: #4a4a4a;
        text-align: left;
        margin-bottom: 1em;
      }

      .text-area {
        width: 100%;
        height: 50px;
        font-family: Roboto, sans-serif;
        padding: 11px;
        font-style: normal;
        font-weight: 500;
        font-size: 11px;
        line-height: 14px;
        color: #7a7a7a;
        border: 1px solid #979797;
        border-radius: 3px;

        &::placeholder {
          color: #000;
          text-transform: uppercase;
          font-size: 12px;
        }

        p {
          font-size: 12px;
          font-style: normal;
          color: #7a7a7a;
        }
      }

      hr {
        border: none;
        margin: 20px 0;
      }
    }

    .empty-attachments {
      cursor: not-allowed;
    }

    .text-area-container {
      display: flex;
      flex-direction: column;
      text-align: end;

      h2 {
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        color: #4a4a4a;
        text-align: left;
        margin-bottom: 1em;
      }

      .text-area {
        width: 100%;
        height: 85px;
        font-family: Roboto, sans-serif;
        padding: 11px;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 14px;
        color: #7a7a7a;
        background: #ffffff;
        border: 1px solid #979797;
        border-radius: 3px;
        resize: none;

        &::placeholder {
          color: #7A7A7A;
          text-transform: uppercase;
        }

        &:disabled {
          background-color: #e1e1e1;
          cursor: not-allowed;
        }
      }

      hr {
        border: 1px dashed #6d6d6d;
        margin: 20px 0;
      }
    }

    .empty-attachments {
      cursor: not-allowed;
    }

    .upload-dropzone {
      background-color: rgb(246, 242, 242);
      width: 100%;
      position: relative;
      padding: 2px 10px;
      border: 1px dashed #7e898a;
      box-sizing: border-box;
      border-radius: 5px;

      @media all and (-ms-high-contrast: none),
      (-ms-high-contrast: active) {
        /* IE10 & IE11 CSS styles go here */
        max-height: 110px;
      }

      .uploading {
        margin: auto;
        padding-top: 1em;
        padding-bottom: 1em;
        cursor: progress;

        p {
          font-family: Roboto, sans-serif;
          font-style: normal;
          font-weight: 400;
          font-size: 18px;
          line-height: 21px;
          color: #a1a1a1;
        }
      }

      .drop-image {
        margin: auto 1em auto auto;

        &--opacity {
          opacity: 0.3;
        }

        &--padding {
          padding: 10px;

          @media all and (-ms-high-contrast: none),
          (-ms-high-contrast: active) {
            /* IE10 & IE11 CSS styles go here */
            padding: 0px;
          }
        }

        .md-icon {
          width: 100%;
          height: 100%;
          max-width: 3em;

          @media all and (-ms-high-contrast: none),
          (-ms-high-contrast: active) {
            /* IE10 & IE11 CSS styles go here */

            svg {
              max-height: 110px;
              width: 65px;
            }
          }
        }
      }

      .upload-instructions {
        margin-top: 10px;
        margin-left: 10px;

        label {
          margin: 11px 0;
          display: block;
          padding: 1px;
          text-align: center;
          height: 32px;

          span {
            overflow: hidden;
            white-space: nowrap;
            width: 88%;
            display: inline-block;
            text-overflow: ellipsis;
            letter-spacing: 1px;
          }
        }

        h2 {
          font-family: Roboto, sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 18px;
          line-height: 21px;
          color: #4a4a4a;
        }

        p {
          font-family: Roboto, sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 18px;
          color: #617173;
          margin-top: 3px;
        }

        .blocked {
          cursor: default !important;
        }

        .uploaded {
          cursor: pointer;
          max-width: 16em;

          span {
            cursor: pointer;
          }
        }
      }

      .upload-dropzone__wrapper {
        display: flex;
        flex-direction: row;
        line-height: 30px;
      }
    }
  }
}

.pendencies-modal .md-dialog {
  max-width: 500px;
  max-height: 95%;

  .md-dialog {
    &-title {
      padding-top: 1em;
    }

    &-content {
      background-color: #f5f5f5;
      padding: 0 34px 24px;
    }
  }

  @media screen and (-ms-high-contrast: active),
  screen and (-ms-high-contrast: none) {
    .md-dialog-content {
      overflow-x: hidden;
    }
  }
}
</style>
